import React from 'react'
import {
  Container as UIFoundationsContainer,
  ContainerFlexGaps,
  ContainerDisplays,
  Icon as UIFoundationsIcon,
  Text as UIFoundationsText,
  TextVariants,
  ContainerFlexAlignItems,
  IconStates,
  useThemeUtils
} from '@dcxwam/dcx-wam-ui-foundations'
import { replacePlaceholders } from '../../../../utils/replace-placeholders'
import { AskaAFriendChannelsProps } from '../AskAFriend/AskAFriendEditConfig'
import { pushDataLayerReferAFriendSend } from './data-layer'

export const SuccessCopyMessageComponent = ({
  content
}: {
  content: string | undefined
}) => {
  const themeUtils = useThemeUtils()
  const iconConfig = {
    image: 'pmi-icon-check-full',
    state: IconStates.Success
  }

  return (
    <UIFoundationsContainer
      display={ContainerDisplays.Flex}
      flexGap={themeUtils.getResponsiveProp([{ x: ContainerFlexGaps.Size_2 }])}
      flexAlignItems={ContainerFlexAlignItems.Center}
    >
      <UIFoundationsIcon {...iconConfig} />
      <UIFoundationsText content={content} variant={TextVariants.Body2} />
    </UIFoundationsContainer>
  )
}

export const getChannelEntries = (
  channels: Array<AskaAFriendChannelsProps>,
  messageToReplace: string,
  encodedMessage: string | undefined
) =>
  channels?.map((channel, index: number) => ({
    id: `${channel?.label} ${index}`,
    image: {
      src: channel?.channelImageUrl,
      alt: channel?.imageAlt
    },
    label: channel?.label,
    supportiveMessage: channel?.supportiveMessage,
    buttonLabel: channel?.ctaLabel,
    additionalContent: undefined,
    onClickAction: () => {
      pushDataLayerReferAFriendSend(channel?.label)
      return null
    },
    linkUrl: replacePlaceholders(channel?.link, [
      [messageToReplace, encodedMessage]
    ])
  }))

export const handleCopyOption = (
  copy: {
    successMessage?: string
    ctaLabel?: string
    copyImageUrl?: string
    imageAlt?: string
    copyOptionLabel?: string
  },
  additionalContent: React.ReactNode,
  onClickAction: () => React.JSX.Element
) => ({
  id: copy?.ctaLabel || '',
  image: {
    src: copy?.copyImageUrl,
    alt: copy?.imageAlt
  },
  label: copy?.copyOptionLabel,
  buttonLabel: copy?.ctaLabel,
  additionalContent,
  onClickAction
})
